import { useContext, useState } from "react";
import { useNavigate } from "react-router-dom";

import { AuthButton, Authorization, Datas, TokenContext } from "../App";
import ProductCard from '../components/ProductCard';
import ProfileButton from '../components/ProfileButton';

import s from '../styles/App.module.css';

interface AddUserResponse {
  subscription: string;
  expire: string | number;
}

const API = 'https://libervpn.ru/api';

function Home() {
  const authButtonContext = useContext(AuthButton);
  const tokenContext = useContext(TokenContext);
  const authContext = useContext(Authorization);
  const datasContext = useContext(Datas);
  const navigate = useNavigate();
  const [isLoading, setIsLoading] = useState<boolean>(false);

  function openLogin() {
    authButtonContext?.setAuthBut(true);
  }

  async function addSubscription() {
    if (authContext?.auth) {
      setIsLoading(true);
      try {
        const response = await fetch(`${API}/adduser`, {
          headers: { 'authorization': `${tokenContext?.token || ''}` }
        });
        const data: AddUserResponse = await response.json();
        datasContext?.setDatas((prev: any) => ({
          ...prev,
          sub_url: data.subscription,
          limit: data.expire,
          free_trial: true
        }));
        navigate('/profile');
      } catch (err) {
        console.error(err);
      } finally {
        setIsLoading(false);
      }
    } else {
      openLogin();
    }
  }

  function scrollToTariffs() {
    document.getElementById('tariffs')?.scrollIntoView({ behavior: 'smooth' });
  }

  return (
    <div className={s.page}>
      <div className={s.navbar}>
        <ProfileButton />
      </div>

      {/* Hero */}
      <div className={s.hero}>
        <div className={s.hero_glow}></div>
        <div className={s.hero_content}>
          <div className={s.badge}>БЕЗОПАСНОСТЬ • СВОБОДА • СКОРОСТЬ</div>
          <h1 className={s.title}>Liber <span className={s.title_accent}>VPN</span></h1>
          
          <div className={s.hero_buttons}>
            <button className={s.trial_btn} onClick={addSubscription} disabled={isLoading}>
              {isLoading ? (
                <svg className={s.spinner} viewBox="0 0 50 50">
                  <circle cx="25" cy="25" r="20" fill="none" strokeWidth="5"/>
                </svg>
              ) : <>Попробовать БЕСПЛАТНО</>}
            </button>
            <button className={s.tariffs_btn} onClick={scrollToTariffs}>
              Посмотреть Тарифы 
            </button>
          </div>
        </div>
      </div>

      {/* Features */}
      <div className={s.features_container}>
        <div className={s.features_bar}>
          <div className={s.feature}>
            <div className={s.feature_icon_outline}>
              <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                <polygon points="13 2 3 14 12 14 11 22 21 10 12 10 13 2" />
              </svg>
            </div>
            <div>
              <p className={s.feature_title}>Высокая скорость</p>
              <p className={s.feature_sub}>Без ограничений</p>
            </div>
          </div>

          <div className={s.feature}>
            <div className={s.feature_icon_outline}>
              <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                <rect x="2" y="3" width="20" height="14" rx="2" ry="2" />
                <line x1="8" y1="21" x2="16" y2="21" />
                <line x1="12" y1="17" x2="12" y2="21" />
              </svg>
            </div>
            <div>
              <p className={s.feature_title}>Доступ на всех устройствах</p>
              <p className={s.feature_sub}>ПК, планшеты, смартфоны</p>
            </div>
          </div>

          <div className={s.feature}>
            <div className={s.feature_icon_outline}>
              <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                <path d="M4.5 16.5c-1.5 1.26-2 5-2 5s3.74-.5 5-2c.71-.84.7-2.13-.09-2.91a2.18 2.18 0 0 0-2.91-.09z"/>
                <path d="m12 15-3-3a22 22 0 0 1 2-3.95A12.88 12.88 0 0 1 22 2c0 2.72-.78 7.5-6 11a22.35 22.35 0 0 1-4 2z"/>
                <path d="M9 12H4s.55-3.03 2-4c1.62-1.08 5 0 5 0"/>
                <path d="M12 15v5s3.03-.55 4-2c1.08-1.62 0-5 0-5"/>
              </svg>
            </div>
            <div>
              <p className={s.feature_title}>Быстрый запуск</p>
              <p className={s.feature_sub}>3 простых шага для запуска</p>
            </div>
          </div>
        </div>
      </div>

      {/* Tariffs */}
      <div id="tariffs" className={s.tariffs_section}>
        <h2 className={s.tariffs_title}>Тарифы</h2>
        <p className={s.tariffs_sub}>Простой выбор. Максимум скорости и условий.</p>
        <div className={s.cards_columns}>
          <ProductCard title='149 ₽' price={149} month='1 МЕСЯЦ' month_amount={30} />
          <ProductCard title='390 ₽' price={390} month='3 МЕСЯЦА' month_amount={90} />
          <ProductCard title='1200 ₽' price={1200} month='12 МЕСЯЦЕВ' month_amount={360} />
        </div>
      </div>
    </div>
  );
}

export { Home };